/** @format */

import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Error404 from '../components/Errors/Error404';
import Layoutapp from '../components/Layout';
// import { Campaign, Pharmacies, PharmaciesTime, Promotions } from '../pages/administration';
// import { BranchOffices } from '../pages/administration/BranchOffices';
// import { SuccessMP } from '../pages/administration/success-mp';
import Recover from '../pages/auth/recover';
import Register from '../pages/auth/register';
// import Banners from '../pages/banners';
// import BarCode from '../pages/barcode';
// import Colors from '../pages/colors';
// import { ComplaintBook, ComplaintMessage } from '../pages/complaint-book';
// import FrontServices from '../pages/front-services';
// import Letters from '../pages/letters';
// import Migration from '../pages/migration';
// import Notifications from '../pages/notifications';
// import OrderServicesDetail from '../pages/order-services/detail';
// import OrderServices from '../pages/order-services/page';
// import ResendPos from '../pages/payments/resendPos';
// import tokenPtoPago from '../pages/payments/tokenPtoPago';
// import PopUp from '../pages/popup';
import Profile from '../pages/profile';
// import QfCriterion from '../pages/qf-criterion';
 import QuotationDetail from '../pages/quotation/detail';
 import Quotation from '../pages/quotation/page';
// import ReservationDetail from '../pages/reservation/detail';
// import Reservation from '../pages/reservation/page';
// import SeoProduct from '../pages/seoproduct';
// import Stocks from '../pages/stocks';
// import TrackingDetail from '../pages/tracking/detail';
// import Tracking from '../pages/tracking/page';
// import AssignRole from '../pages/users/AssignRole';
// import Email from '../pages/users/Email';
// import FindUser from '../pages/users/FindUser';
// import SetLocal from '../pages/users/SetLocal';

import ScrollToTop from '../v2-components/ScrollToTop';

import AdminMigrationPage from '../v2-pages/admin-migration';
import AdminReportPage from '../v2-pages/admin-report';
import AdminReserveListPage from '../v2-pages/admin-reserve/reserve-list';
import AdminListPage from '../v2-pages/admin-tracking/orders-list';
import MigrationPage from '../v2-pages/migration';
// import NotificationDetailPage from '../v2-pages/notification/notification-detail';
import NotificationsListPage from '../v2-pages/notification/notifications-list';
import PharmacyLocalsDetailsPage from '../v2-pages/pharmacy-locals/details';
import PharmacyLocalsListPage from '../v2-pages/pharmacy-locals/list';
import ReportPage from '../v2-pages/report';
import ReserveDetailPage from '../v2-pages/reserve/reserve-detail';
import ReserveListPage from '../v2-pages/reserve/reserve-list';
import OrderDetailPage from '../v2-pages/tracking/order-detail';
import OrdersListPage from '../v2-pages/tracking/orders-list';
import AdminPharmacySliderTemplatesPage from '../v2-pages/admin-pharmacy-sliders/templates';
import AdminPharmacySliderLocationsPage from '../v2-pages/admin-pharmacy-sliders/locations';
import AdminPharmacySliderResultsPage from '../v2-pages/admin-pharmacy-sliders/results';
import AdminPharmacySlidersCreatePage from '../v2-pages/admin-pharmacy-sliders/create';
import ClaimsDetailPage from '../v2-pages/claims/claims-detail';
import ClaimsListPage from '../v2-pages/claims/claims-list';
import AdminClaimsListPage from '../v2-pages/admin-claims/claims-list';
import AdminPharmacyLocalsListPage from '../v2-pages/admin-pharmacy-locals/list';
import AdminQfCriterionV2 from '../v2-pages/admin-qf-criterion';
import QfCriterionV2 from '../v2-pages/qf-criterion';
import AdminLetters from '../v2-pages/admin-letters';
import LettersV2 from '../v2-pages/letters';
import AdminStock from '../v2-pages/admin-stock';
import StockV2 from '../v2-pages/stock';
import ResendPosV2 from '../v2-pages/payments/resendPos';
import TokenPtoPagoV2 from '../v2-pages/payments/tokenPtoPago';

// import AssignRoleV2 from '../v2-pages/users/AssignRole';
// import SetLocalV2 from '../v2-pages/users/SetLocal';
// import EmailV2 from '../v2-pages/users/Email';
// import FindUserV2 from '../v2-pages/users/FindUser';

import UserManagement from '../v2-pages/user-management';
import UserDetailPage from '../v2-pages/user-management/user-detail';

import AdminUserManagement from '../v2-pages/admin-user-management';
import AdminAddUser from '../v2-pages/admin-user-management/add-user';
import AdminUserDetailPage from '../v2-pages/admin-user-management/user-detail';

import PharmacySlidersCreatePage from '../v2-pages/pharmacy-sliders/create';
import PharmacySliderResultsPage from '../v2-pages/pharmacy-sliders/results';
import PharmacySliderLocationsPage from '../v2-pages/pharmacy-sliders/locations';
import PharmacySliderTemplatesPage from '../v2-pages/pharmacy-sliders/templates';
import PrivateRoute from '../v2-components/PrivateRoute';
import { isPanelModuleEnabled } from '../_config/countries/panel-modules.config';
import LoginV2 from '../v2-pages/auth/login';
import ClaimsDetailAdminPage from '../v2-pages/admin-claims/claims-detail';
import LandingPage from '../v2-pages/admin-landing/landing';
import LandingDetailPage from '../v2-pages/admin-landing/detail';
import LandingCreatePage from '../v2-pages/admin-landing/create';
import LandingProductListPage from '../v2-pages/admin-landing/product-list';
import CarouselAdminPage from '../v2-pages/admin-carousel/carousel';
import CarouselDetailAdminPage from '../v2-pages/admin-carousel/detail';
import CarouselCreateAdminPage from '../v2-pages/admin-carousel/create';
import CarouselPage from '../v2-pages/carousel/carousel';
import CarouselDetailPage from '../v2-pages/carousel/detail';
import CarouselCreatePage from '../v2-pages/carousel/create';
import QuotationListPage from '../v2-pages/quotation/quotation-list';
import QuotationDetailPage from '../v2-pages/quotation/quotation-detail';
import QuotationDetailAdminPage from '../v2-pages/admin-quotation/quotation-detail';
import QuotationListAdminPage from '../v2-pages/admin-quotation/quotation-list';
import UserLandingPage from '../v2-pages/landing/landing';
import UserLandingDetailPage from '../v2-pages/landing/detail';
import UserLandingCreatePage from '../v2-pages/landing/create';
import UserLandingProductListPage from '../v2-pages/landing/product-list';
import AdminPharmacyIconTemplatesPage from '../v2-pages/admin-pharmacy-icons/templates';
import AdminPharmacyIconCreatePage from '../v2-pages/admin-pharmacy-icons/create';
import PharmacyIconCreatePage from '../v2-pages/pharmacy-icons/create';
import PharmacyIconTemplatesPage from '../v2-pages/pharmacy-icons/templates';
import AdminPharmacyIconLocationsPage from '../v2-pages/admin-pharmacy-icons/locations';
import PreorderDetailPage from '../v2-pages/preorder/preorder-detail';
import PreorderListPage from '../v2-pages/preorder/preorder-list';

export default function Router() {
	return (
		<BrowserRouter>
			<ScrollToTop />
			<Layoutapp>
				<Switch>
					<Route exact path="/login" component={LoginV2} />
					<Route exact path="/" component={ReportPage} />
					<Route exact path="/recover" component={Recover} />
					<Route exact path="/profile-user" component={Profile} />
					<Route exact path="/register" component={Register} />

					{/* <Route exact path="/notifications" component={Notifications} />

					<Route exact path="/barcode" component={BarCode} />
					<Route exact path="/seo-product" component={SeoProduct} />

					<Route exact path="/services/:page" component={OrderServices} />
					<Route exact path="/services/detail/:serviceId" component={OrderServicesDetail} />

					<Route exact path="/menu-front" component={FrontServices} />

					<Route exact path="/popup" component={PopUp} />

					<Route exact path="/stock/:pharmacy" component={Stocks} />

					<Route exact path="/colors/:pharmacy" component={Colors} />

					<Route exact path="/banners/:category/:page" component={Banners} />

					<Route exact path="/letters/:pharmacy" component={Letters} />

					<Route exact path="/migration/:pharmacy" component={Migration} />

					<Route exact path="/users/assign-role" component={AssignRole} />
					<Route exact path="/users/set-local" component={SetLocal} />
					<Route exact path="/users/email" component={Email} />
					<Route exact path="/users/find" component={FindUser} />

					<Route exact path="/payments/resendPos" component={ResendPos} />
					<Route exact path="/payments/token-pto-pago" component={tokenPtoPago} />

					<Route exact path="/qf-criterion/:pharmacy/:page" component={QfCriterion} />

					<Route exact path="/complaint-book/:pharmacy/:page" component={ComplaintBook} />
					<Route exact path="/complaint-book-message/:claim_token" component={ComplaintMessage} />

					<Route exact path="/quotes/:pharmacy/:status/:type/:page" component={Quotation} />
					<Route exact path={['/quote/:pharmacy/:_id', '/quote/general/:rut/:short_code']} component={QuotationDetail} />

					<Route exact path="/reserve/:pharmacy/:status/:type/:page" component={Reservation} />
					<Route exact path={'/reserve/:pharmacy/:_id'} component={ReservationDetail} />

					<Route exact path="/administration/pharmacies" component={Pharmacies} />
					<Route exact path="/administration/pharmacies/branch-offices/:pharmacy/:sucursal" component={BranchOffices} />
					<Route exact path="/mp/success" component={SuccessMP} />

					<Route exact path="/administration/promotions/:pharmacy/:page" component={Promotions} />
					<Route exact path="/administration/pharmacies-time/:pharmacy/:page" component={PharmaciesTime} />
					<Route exact path="/administration/agreement/campaign/:pharmacy/:page" component={Campaign} />

					<Route exact path="/tracking/:pharmacy/:status/:month/:page" component={Tracking} />
					<Route exact path="/tracking/detail/:pharmacy/:trx_id" component={TrackingDetail} /> */}

				{isPanelModuleEnabled('quotation') && (
					<Route exact path="/quotes/:pharmacy/:status/:type/:page" component={Quotation} />
				)}
				{isPanelModuleEnabled('quotation') && (
					<Route
						exact
						path={['/quote/:pharmacy/:_id', '/quote/general/:rut/:short_code']}
						component={QuotationDetail}
					/>
				)}

					{isPanelModuleEnabled('reserve') && (
						<Route exact path="/v2/reserve/detail/:trx_id" component={ReserveDetailPage} />
					)}
					{isPanelModuleEnabled('reserve') && (
						<Route exact path="/v2/reserve/list" component={ReserveListPage} />
					)}

					<Route exact path="/v2/report" component={ReportPage} />
					<PrivateRoute exact path="/v2/admin-report" component={AdminReportPage} />

					<Route exact path="/migration2" component={MigrationPage} />
					<PrivateRoute exact path="/v2/admin-migration" component={AdminMigrationPage} />

					{isPanelModuleEnabled('reserve') && (
						<PrivateRoute exact path="/v2/admin-reserve/list" component={AdminReserveListPage} />
					)}

					<Route path="/v2/pharmacy-locals/list" component={PharmacyLocalsListPage} />
					<PrivateRoute path="/v2/admin-pharmacy-locals/list" component={AdminPharmacyLocalsListPage} />
					<Route path="/v2/pharmacy-locals/detail/:id" component={PharmacyLocalsDetailsPage} />

					<Route path="/v2/tracking/detail/:pharmacy/:id" component={OrderDetailPage} />
					<Route path="/v2/tracking/list" component={OrdersListPage} />
					<PrivateRoute path="/v2/admin-tracking/list" component={AdminListPage} />

					<Route path="/v2/notifications/list" component={NotificationsListPage} />
					{/* <Route path="/v2/notification/detail/:id" component={NotificationDetailPage} /> */}

					<PrivateRoute
						path="/v2/admin-pharmacy-sliders/templates/:template/locations/:location/create"
						component={AdminPharmacySlidersCreatePage}
					/>
					<PrivateRoute
						path="/v2/admin-pharmacy-sliders/templates/:template/locations/:location"
						component={AdminPharmacySliderResultsPage}
					/>
					<PrivateRoute path="/v2/admin-pharmacy-sliders/templates/:template" component={AdminPharmacySliderLocationsPage} />
					<PrivateRoute path="/v2/admin-pharmacy-sliders/" component={AdminPharmacySliderTemplatesPage} />
					
					<PrivateRoute path="/v2/admin-pharmacy-icons/templates/:template/locations/:location/create" component={AdminPharmacyIconCreatePage} />
					<PrivateRoute path="/v2/admin-pharmacy-icons/templates/:template" component={AdminPharmacyIconLocationsPage} />
					<PrivateRoute path="/v2/admin-pharmacy-icons/" component={AdminPharmacyIconTemplatesPage} />
					

					<Route path="/v2/pharmacy-sliders/templates/:template/locations/:location/create" component={PharmacySlidersCreatePage} />
					<Route path="/v2/pharmacy-sliders/templates/:template/locations/:location" component={PharmacySliderResultsPage} />
					<Route path="/v2/pharmacy-sliders/templates/:template" component={PharmacySliderLocationsPage} />
					<Route path="/v2/pharmacy-sliders/" component={PharmacySliderTemplatesPage} />

					<Route path="/v2/pharmacy-icons/templates/:template/locations/:location/create" component={PharmacyIconCreatePage} />
					<Route path="/v2/pharmacy-icons/" component={PharmacyIconTemplatesPage} />

					<Route path="/v2/claims/list" component={ClaimsListPage} />
					<PrivateRoute path="/v2/admin-claims/list" component={AdminClaimsListPage} />
					<PrivateRoute path="/v2/admin-claims/detail/:id" component={ClaimsDetailAdminPage} />
					<Route path="/v2/claims/detail/:id" component={ClaimsDetailPage} />

					{isPanelModuleEnabled('qfCriterion') && (
						<PrivateRoute exact path="/v2/admin-qf-criterion/list" component={AdminQfCriterionV2} />
					)}
					{isPanelModuleEnabled('qfCriterion') && (
						<Route exact path="/v2/qf-criterion/list" component={QfCriterionV2} />
					)}

					<PrivateRoute exact path="/v2/admin-letters" component={AdminLetters} />
					<Route exact path="/v2/letters" component={LettersV2} />

					<PrivateRoute exact path="/v2/admin-stock" component={AdminStock} />
					<Route exact path="/v2/stock" component={StockV2} />

					<PrivateRoute exact path="/v2/payments/resendPos" component={ResendPosV2} />
					<PrivateRoute exact path="/v2/payments/token-pto-pago" component={TokenPtoPagoV2} />

					{/* <PrivateRoute exact path="/v2/users/assign-role" component={AssignRoleV2} />
					<PrivateRoute exact path="/v2/users/set-local" component={SetLocalV2} />
					<PrivateRoute exact path="/v2/users/email" component={EmailV2} />
					<PrivateRoute exact path="/v2/users/find" component={FindUserV2} /> */}


					<Route exact path="/v2/user-management" component={UserManagement} />
					<Route exact path="/v2/user-management/users/:email" component={UserDetailPage} />

					<PrivateRoute exact path="/v2/admin-user-management" component={AdminUserManagement} />
					<PrivateRoute exact path="/v2/admin-user-management/users/add" component={AdminAddUser} />
					<PrivateRoute exact path="/v2/admin-user-management/users/:email" component={AdminUserDetailPage} />

					<PrivateRoute exact path="/landing" component={LandingPage} />
					<PrivateRoute exact path="/landing/detail" component={LandingDetailPage} />
					<PrivateRoute exact path="/landing/create" component={LandingCreatePage} />
					<PrivateRoute exact path="/landing/create/product-list" component={LandingProductListPage} />

					<PrivateRoute exact path="/admin-carousel" component={CarouselAdminPage} />
					<PrivateRoute exact path="/admin-carousel/detail" component={CarouselDetailAdminPage} />
					<PrivateRoute exact path="/admin-carousel/create" component={CarouselCreateAdminPage} />

					<Route exact path="/user-landing" component={UserLandingPage} />
					<Route exact path="/user-landing/detail" component={UserLandingDetailPage} />
					<Route exact path="/user-landing/create" component={UserLandingCreatePage} />
					<Route exact path="/user-landing/create/product-list" component={UserLandingProductListPage} />

					<Route exact path="/carousel" component={CarouselPage} />
					<Route exact path="/carousel/detail" component={CarouselDetailPage} />
					<Route exact path="/carousel/create" component={CarouselCreatePage} />

					{isPanelModuleEnabled('quotation') && (
						<Route exact path="/quotation" component={QuotationListPage} />
					)}
					{isPanelModuleEnabled('quotation') && (
						<Route exact path="/quotation/detail/:id" component={QuotationDetailPage} />
					)}
					{isPanelModuleEnabled('quotation') && (
						<PrivateRoute exact path="/admin-quotation" component={QuotationListAdminPage} />
					)}
					{isPanelModuleEnabled('quotation') && (
						<PrivateRoute exact path="/admin-quotation/detail/:id" component={QuotationDetailAdminPage} />
					)}

					{isPanelModuleEnabled('preorder') && (
						<Route exact path="/preorder" component={PreorderListPage} />
					)}
					{isPanelModuleEnabled('preorder') && (
						<Route exact path="/preorder/detail/:id" component={PreorderDetailPage} />
					)}


					<Route component={Error404} />
				</Switch>
			</Layoutapp>
		</BrowserRouter>
	);
}
